import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app/app.service';
import { Model, SurveyNG, StylesManager } from "survey-angular";
StylesManager.applyTheme("modern");

var marsJson = {
  showCompletedPage: false,
  pages: [
    {
      title: "Contact Details.",
      name: "page1",
      elements: [{
        type: "text",
        name: "FirstName",
        title: "Enter your first name:",
        isRequired: true
      }, {
        type: "text",
        name: "LastName",
        title: "Enter your last name:",
        isRequired: false
      }, {
        type: "text",
        name: "Email",
        inputType: "email",
        title: "Enter your email:",
        isRequired: false
      }, {
        type: "text",
        inputType: "number",
        name: "Phone",
        title: "Enter your phone:",
        isRequired: true,
        min: 55555555,
        max: 99999999999999
      }, {
        type: "text",
        inputType: "number",
        name: "Age",
        title: "Enter your age:",
        isRequired: true,
        min: 1,
        max: 120
      }]
    },
    {
      title: "Categories",
      name: "page2",
      elements: [
        {
          type: "radiogroup",
          name: "category",
          title: "Select a category to proceed",
          hasOther: false,
          isRequired: true,
          choices: [
            {
              value: "Hair",
              text: "Hair"
            }, {
              value: "Wellness",
              text: "Wellness"
            }, {
              value: "Beard",
              text: "Beard"
            }, {
              value: "Skin",
              text: "Skin"
            },
            {
              value: "Performance",
              text: "Performance"
            }
          ],
          colCount: 5
        },
        {
          type: "panel",
          name: "panel1",
          title: "Hair Assesment",
          visibleIf: "{category} = Hair",
          elements: [
            {
              type: "imagepicker",
              name: "ques1",
              title: "Where is the hairloss?",
              isRequired: true,
              colCount: 3,
              choices: [
                {
                  value: "Stage 1",
                  imageLink: "../../assets/img/baldness/Stages-01.png"
                },
                {
                  value: "Stage 2",
                  imageLink: "../../assets/img/baldness/Stages-02.png"
                },
                {
                  value: "Stage 3",
                  imageLink: "../../assets/img/baldness/Stages-03.png"
                },
                {
                  value: "Stage 4",
                  imageLink: "../../assets/img/baldness/Stages-04.png"
                },
                {
                  value: "Stage 5",
                  imageLink: "../../assets/img/baldness/Stages-05.png"
                },
                {
                  value: "Stage 6",
                  imageLink: "../../assets/img/baldness/Stages-06.png"
                }
              ]
            },
            {
              type: "radiogroup",
              name: "ques2",
              title: "Do you have any family history of baldness?",
              hasOther: false,
              isRequired: true,
              choices: ["Yes", "No"]
            },
            {
              type: "radiogroup",
              name: "ques3",
              title: "May I know your water intake per day in litres?",
              hasOther: false,
              isRequired: false,
              choices: ["1-2 lts", "2-3 lts", "3-4 lts", "More than 4 lts"]
            },
            {
              type: "text",
              name: "ques4",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "ques5",
              title: "What all lifestyle changes you implemented?",
              hasOther: true,
              isRequired: false,
              choices: ["Water intake", "Food intake", "Sleeping pattern", "Work style"]
            },
            {
              type: "text",
              name: "ques6",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "ques7",
              title: "Which type of food do you mostly consume?",
              hasOther: false,
              isRequired: false,
              choices: ["Homemade", "Outside food", "Oily", "Junk", "Healthy"]
            },
            {
              type: "radiogroup",
              name: "ques8",
              title: "May I know your sleeping pattern?",
              hasOther: false,
              isRequired: false,
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "more than 6 hrs"]
            },
            {
              type: "radiogroup",
              name: "ques9",
              title: "How about your work style?",
              hasOther: false,
              isRequired: false,
              choices: ["9 hrs", "10-11 hrs", "11-12 hrs", "more than 12 hrs"]
            },
            {
              type: "radiogroup",
              name: "ques10",
              title: "How was your hair pattern before hair loss?",
              hasOther: false,
              isRequired: false,
              choices: ["Thick", "Medium", "Thin"]
            },
            {
              type: "radiogroup",
              name: "ques11",
              title: "Do you have any Pre-existing problems?",
              hasOther: true,
              isRequired: false,
              colCount: 3,
              choices: ["Thyroid", "Hypertension", "Diabetes", "Indigestion", "Heart", "Kidney Problem", "No Such Problem"]
            },
            {
              type: "multipletext",
              name: "ques12",
              title: "Since when are you facing hair loss?",
              hasOther: false,
              isRequired: false,
              colCount: 3,
              "items": [
                {
                  "inputType": "number",
                  "name": "Days",
                  "title": "Days"
                },
                {
                  "inputType": "number",
                  "name": "Months",
                  "title": "Months"
                },
                {
                  "inputType": "number",
                  "name": "Years",
                  "title": "Years"
                }
              ]
            },
            {
              type: "text",
              name: "ques13",
              title: "How are your results?",
              isRequired: false
            },
            {
              type: "multipletext",
              name: "ques14",
              title: "Since when are you using this product/combo?",
              hasOther: false,
              isRequired: false,
              colCount: 3,
              "items": [
                {
                  "inputType": "number",
                  "name": "Days",
                  "title": "Days"
                },
                {
                  "inputType": "number",
                  "name": "Months",
                  "title": "Months"
                },
                {
                  "inputType": "number",
                  "name": "Years",
                  "title": "Years"
                }
              ]
            }
          ]
        },
        {
          type: "panel",
          name: "panel1",
          title: "Wellness Assesment",
          visibleIf: "{category} = Wellness",
          elements: [
            {
              type: "text",
              inputType: "number",
              name: "weight",
              title: "Please enter your weight below (in kgs)",
              isRequired: true
            },
            {
              type: "text",
              inputType: "number",
              name: "height",
              title: "Please enter your height below (in cms)",
              isRequired: true
            },
            {
              type: "text",
              name: "1",
              title: "Since when are you using this product/combo?",
              isRequired: false
            },
            {
              type: "text",
              name: "2",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "text",
              name: "3",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "4",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "radiogroup",
              name: "5",
              title: "How many days do you exercise in a week?",
              choices: ["Don't work out at all", "Daily", "5-6 times a week", "1-2 times a week"],
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "6",
              title: "Do you have any pre-existing problems?",
              choices: ["Cholestrol", "Thyroid", "Heart", "Diabetes", "Kidney Problem", "No Such Problem"],
              isRequired: true,
              hasOther: true,
              colCount: 3
            },
            {
              type: "radiogroup",
              name: "7",
              title: "Does anyone in your family are Overweight or Obese?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "8",
              title: "May I know your water intake per day in litres?",
              choices: ["1-2 lts", "2-3 lts", "3-4 lts", "More than 4 lts"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "9",
              title: "Which type of food do you mostly consume?",
              choices: ["Homemade", "Outside food", "Oily", "Junk", "Healthy"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "10",
              title: "May I know your sleeping pattern?",
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "more than 6 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "11",
              title: "How about your work style?",
              choices: ["9 hrs", "10-11 hrs", "11-12 hrs", "more than 13 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "12",
              title: "Do you smoke or drink?",
              choices: ["Daily", "Occasionally", "Never"],
              isRequired: false
            },
            {
              type: "text",
              name: "13",
              title: "How are your results?",
              isRequired: false
            }
          ]
        },
        {
          type: "panel",
          name: "panel1",
          title: "Beard Assesment",
          visibleIf: "{category} = Beard",
          elements: [
            {
              type: "radiogroup",
              name: "question1",
              title: "What exactly are you looking for?",
              choices: ["Beard Growth", "Beard Care"],
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "question2",
              title: "How is your beard condition currently?",
              choices: ["Patchy Beard", "No Beard", "Very less (Only moustaches and chin hair)", " Excellent beard, Just need something for beard care"],
              isRequired: true
            },
            {
              type: "text",
              name: "question3",
              title: "Since when are you using this product/combo?",
              isRequired: false
            },
            {
              type: "text",
              name: "question4",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "text",
              name: "question5",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "question6",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "radiogroup",
              name: "question7",
              title: "Does anyone in your family have beard growth issues?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "question8",
              title: "Do you have any Pre-existing problems?",
              choices: ["Thyroid", "Hypertension", "Diabetes", "Indigestion", "Heart", "Kidney Problem", "No Such Problem"],
              isRequired: false,
              hasOther: true,
              colCount: 3
            },
            {
              type: "radiogroup",
              name: "question9",
              title: "May I know your water intake per day in litres?",
              choices: ["1-2 lts", "2-3 lts", "3-4 lts", "More than 4 lts"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "question10",
              title: "May I know your sleeping pattern?",
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "More than 6 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "question10",
              title: "Did you use any Beard products before this?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "text",
              name: "question11",
              title: "How are your results?",
              isRequired: false
            }
          ]
        },
        {
          type: "panel",
          name: "panel1",
          title: "Skin Assesment",
          visibleIf: "{category} = Skin",
          elements: [
            {
              type: "text",
              name: "q1",
              title: "May I know your city and state",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q2",
              title: "Are you allergic to any of the ingredients below?",
              isRequired: true,
              choices: ["Vitamin C", "Salicylic Acid", "Retinol", "Kojic Acid", "None"]
            },
            {
              type: "radiogroup",
              name: "q3",
              title: "Please select your skin concern",
              choices: ["Open pores", "Pigmentation", "Acne", "Aging", "Dark circles", "Spots & Marks", "Dull skin"],
              isRequired: true
            },
            {
              type: "text",
              name: "q4",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "text",
              name: "q5",
              title: "Since when are you using this product/combo?",
              isRequired: false
            },
            {
              type: "text",
              name: "q6",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q7",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "radiogroup",
              name: "q8",
              title: "Please select your skin texture",
              choices: ["Oily", "Dry", "Combined"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q9",
              title: "May I know your water intake per day in litres?",
              choices: ["1-2 lts", "2-3 lts", "3-4 lts", "More than 4 lts"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q10",
              title: "Which type of food do you mostly consume?",
              choices: ["Homemade", "Outside food", "Oily", "Junk", "Healthy"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q11",
              title: "May I know your sleeping pattern?",
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "More than 6 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q12",
              title: "How about your work style?",
              choices: ["9 hrs", "10-11 hrs", "11-12 hrs", "More than 13+ hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q13",
              title: "Do you have any Pre-existing problems?",
              choices: ["Thyroid", "Hypertension", "Diabetes", "Indigestion", "Heart", "Kidney Problem", "No Such Problem"],
              isRequired: true,
              hasOther: true,
              colCount: 3
            },
            {
              type: "radiogroup",
              name: "q14",
              title: "Did you use any Skin products before this?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "text",
              name: "q15",
              title: "How are your results?",
              isRequired: false
            }
          ]
        },
        {
          type: "panel",
          name: "panel1",
          title: "Performance Assesment",
          visibleIf: "{category} = Performance",
          elements: [
            {
              type: "text",
              name: "one",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "two",
              title: "How often do you have trouble getting or keeping an erection during sex?",
              choices: ["Everytime", "Half of the time", "Occasionally", "Rarely"],
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "three",
              title: "How often are you climaxing sooner than you would like during sex?",
              choices: ["Everytime", "Half of the time", "Occasionally", "No issues with ejaculation"],
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "four",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "radiogroup",
              name: "five",
              title: "Do you experience any cramps or tiredness while performing?",
              choices: ["Yes", "No"],
              isRequired: true
            },
            {
              type: "text",
              name: "six",
              title: "Since when are you using this product/combo?",
              isRequired: false
            },
            {
              type: "text",
              name: "seven",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "eight",
              title: "Do you have any Pre-existing problems?",
              choices: ["Thyroid", "Hypertension", "Diabetes", "Indigestion", "Heart", "Kidney Problem", "No Such Problem"],
              hasOther: true,
              isRequired: false,
              colCount: 3
            },
            {
              type: "radiogroup",
              name: "nine",
              title: "Which type of food do you mostly consume?",
              choices: ["Homemade food", "Outside food", "Oily", "Junk", "Healthy"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "ten",
              title: "May I know your sleeping pattern?",
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "More than 6 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "eleven",
              title: "How about your work style?",
              choices: ["9 hrs", "10-11 hrs", "11-12 hrs", "More than 13 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "twelve",
              title: "Do you smoke or drink?",
              choices: ["Daily", "Occasionally", "Never"],
              isRequired: false
            },
            {
              type: "multipletext",
              name: "thirteen",
              title: "Since how long are you married?",
              colCount: 3,
              "items": [
                {
                  "inputType": "number",
                  "name": "Days",
                  "title": "Days"
                },
                {
                  "inputType": "number",
                  "name": "Months",
                  "title": "Months"
                },
                {
                  "inputType": "number",
                  "name": "Years",
                  "title": "Years"
                }
              ],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "forteen",
              title: "Do you want to increase the sexual performance duration?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "fifteen",
              title: "Do you have ED problem?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "multipletext",
              visibleIf: "{fifteen} = Yes",
              name: "sixteen",
              title: "Since how long have you been facing this ED problem?",
              colCount: 3,
              "items": [
                {
                  "inputType": "number",
                  "name": "Days",
                  "title": "Days"
                },
                {
                  "inputType": "number",
                  "name": "Months",
                  "title": "Months"
                },
                {
                  "inputType": "number",
                  "name": "Years",
                  "title": "Years"
                }
              ],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "seventeen",
              title: "Did you use any Performance products before this?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "text",
              name: "eighteen",
              title: "How are your results?",
              isRequired: false
            }
          ]
        }
      ]
    }
  ],
  showQuestionNumbers: "off"
}

var saturnJson = {
  showCompletedPage: false,
  pages: [
    {
      title: "Contact Details.",
      name: "page1",
      elements: [{
        type: "text",
        name: "FirstName",
        title: "Enter your first name:",
        isRequired: true
      }, {
        type: "text",
        name: "LastName",
        title: "Enter your last name:",
        isRequired: false
      }, {
        type: "text",
        name: "Email",
        inputType: "email",
        title: "Enter your email:",
        isRequired: false
      }, {
        type: "text",
        name: "Phone",
        inputType: "number",
        title: "Enter your phone:",
        isRequired: true,
        min: 55555555,
        max: 99999999999999
      }, {
        type: "text",
        name: "Age",
        inputType: "number",
        title: "Enter your age:",
        isRequired: true,
        min: 1,
        max: 120
      }]
    },
    {
      title: "Categories",
      name: "page2",
      elements: [
        {
          type: "radiogroup",
          name: "category",
          title: "Select a category to proceed",
          hasOther: false,
          isRequired: true,
          choices: [
            {
              value: "Hair",
              text: "Hair"
            },
            {
              value: "Wellness",
              text: "Wellness"
            },
            {
              value: "Skin",
              text: "Skin"
            }
          ],
          colCount: 5
        },
        {
          type: "panel",
          name: "panel1",
          title: "Hair Assesment",
          visibleIf: "{category} = Hair",
          elements: [
            {
              type: "imagepicker",
              name: "ques1",
              title: "What best describes your current hairloss condition?",
              isRequired: true,
              colCount: 4,
              choices: [
                {
                  value: "Receding hairline",
                  imageLink: "../../assets/img/baldness/receding.png"
                },
                {
                  value: "Thinning at the crown",
                  imageLink: "../../assets/img/baldness/crown_thin.png"
                },
                {
                  value: "Overall hair loss/thinning",
                  imageLink: "../../assets/img/baldness/overall.png"
                },
                {
                  value: "Receding + overall thinning",
                  imageLink: "../../assets/img/baldness/receding+thin.png"
                }
              ]
            },
            {
              type: "radiogroup",
              name: "ques2",
              title: "What are the results you are looking for?",
              hasOther: false,
              isRequired: true,
              choices: ["Regrowing your hair", "Preventing future hairloss", "Both regrowth & loss prevention"]
            },
            {
              type: "radiogroup",
              name: "ques3",
              title: "Does anyone in your family have hair loss?",
              hasOther: false,
              isRequired: true,
              choices: ["Yes", "No"]
            },
            {
              type: "radiogroup",
              name: "ques4",
              title: "Do you have any upcoming functions in the family in the next 30 days?",
              hasOther: false,
              isRequired: true,
              choices: ["Yes", "No"]
            },
            {
              type: "radiogroup",
              name: "ques5",
              title: "May I know your sleeping pattern?",
              hasOther: false,
              isRequired: false,
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "more than 6 hrs"]
            },
            {
              type: "radiogroup",
              name: "ques6",
              title: "Do you have any Pre-existing problems?",
              hasOther: true,
              isRequired: false,
              colCount: 3,
              choices: ["Thyroid", "Hypertension", "Diabetes", "Indigestion", "Heart", "Kidney Problem", "No Such Problem"]
            },
            {
              type: "multipletext",
              name: "ques7",
              title: "Since when are you facing hair loss?",
              hasOther: false,
              isRequired: false,
              colCount: 3,
              "items": [
                {
                  "inputType": "number",
                  "name": "Days",
                  "title": "Days"
                },
                {
                  "inputType": "number",
                  "name": "Months",
                  "title": "Months"
                },
                {
                  "inputType": "number",
                  "name": "Years",
                  "title": "Years"
                }
              ]
            },
            {
              type: "radiogroup",
              name: "ques8",
              title: "Do you smoke or drink?",
              hasOther: false,
              isRequired: false,
              choices: ["Daily", "Occasionally", "Never"]
            },
            {
              type: "radiogroup",
              name: "ques9",
              title: "Did you use any Hair products before?",
              hasOther: false,
              isRequired: false,
              choices: ["Yes", "No"]
            },
            {
              type: "text",
              name: "ques10",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "ques11",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "text",
              name: "ques12",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "text",
              name: "ques13",
              title: "How are your results?",
              isRequired: false
            }
          ]
        },
        {
          type: "panel",
          name: "panel1",
          title: "Wellness Assesment",
          visibleIf: "{category} = Wellness",
          elements: [
            {
              type: "text",
              name: "weight",
              inputType: "number",
              title: "Please enter your weight below (in kgs)",
              isRequired: true
            },
            {
              type: "text",
              name: "height",
              inputType: "number",
              title: "Please enter your height below (in cms)",
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "1",
              title: "How many days do you exercise in a week?",
              choices: ["Don't work out at all", "Daily", "5-6 times a week", "1-2 times a week"],
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "2",
              title: "Do you have any pre-existing problems?",
              choices: ["Cholestrol", "Thyroid", "Heart", "Diabetes", "Kidney Problem", "No Such Problem"],
              isRequired: true,
              hasOther: true,
              colCount: 3
            },
            {
              type: "radiogroup",
              name: "3",
              title: "Does anyone in your family are Overweight or Obese?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "4",
              title: "May I know your water intake per day in litres?",
              choices: ["1-2 lts", "2-3 lts", "3-4 lts", "More than 4 lts"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "5",
              title: "Which type of food do you mostly consume?",
              choices: ["Homemade", "Outside food", "Oily", "Junk", "Healthy"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "6",
              title: "May I know your sleeping pattern?",
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "more than 6 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "7",
              title: "How often do you eat meals in a day (including tea, coffee, fruits, salads, snacks, etc?",
              choices: ["Greater than 6 times", "Daily", "5-6 times", "1-2 times a week"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "8",
              title: "Do you smoke or drink?",
              choices: ["Daily", "Occasionally", "Never"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "9",
              title: "Did you use any Wellness products before?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "text",
              name: "10",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "11",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "text",
              name: "12",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "text",
              name: "13",
              title: "How are your results?",
              isRequired: false
            }
          ]
        },
        {
          type: "panel",
          name: "panel1",
          title: "Skin Assesment",
          visibleIf: "{category} = Skin",
          elements: [
            {
              type: "text",
              name: "q1",
              title: "May I know your city and state",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q2",
              title: "Are you allergic to any of the ingredients below?",
              isRequired: true,
              choices: ["Vitamin C", "Salicylic Acid", "Retinol", "Kojic Acid", "None"]
            },
            {
              type: "radiogroup",
              name: "q3",
              title: "Please select your skin concern",
              choices: ["Open pores", "Pigmentation", "Acne", "Aging", "Dark circles", "Spots & Marks", "Dull skin"],
              isRequired: true
            },
            {
              type: "radiogroup",
              name: "q4",
              title: "Please select your skin type",
              choices: ["Oily", "Dry", "Combined"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q5",
              title: "How often do you get Acne/Pimples on your skin?",
              choices: ["Once in a month", "Always present"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q6",
              title: "May I know your water intake per day in litres?",
              choices: ["1-2 lts", "2-3 lts", "3-4 lts", "More than 4 lts"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q7",
              title: "Which type of food do you mostly consume?",
              choices: ["Homemade", "Outside food", "Oily", "Junk", "Healthy"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q8",
              title: "May I know your sleeping pattern?",
              choices: ["3-4 hrs", "4-5 hrs", "5-6 hrs", "More than 6 hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q9",
              title: "How about your work style?",
              choices: ["9 hrs", "10-11 hrs", "11-12 hrs", "More than 13+ hrs"],
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q10",
              title: "Do you have any Pre-existing problems?",
              choices: ["Thyroid", "Hypertension", "Diabetes", "Indigestion", "Heart", "Kidney Problem", "No Such Problem"],
              colCount: 3,
              hasOther: true,
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q11",
              title: "Did you use any Skin products before this?",
              choices: ["Yes", "No"],
              isRequired: false
            },
            {
              type: "text",
              name: "q12",
              title: "How is your Treatment plan going on?",
              isRequired: false
            },
            {
              type: "radiogroup",
              name: "q13",
              title: "What all lifestyle changes you implemented?",
              choices: ["Water intake", "Food Intake", "Sleeping pattern", "Work style"],
              isRequired: false,
              hasOther: true
            },
            {
              type: "text",
              name: "q14",
              title: "How are you using the product?",
              isRequired: false
            },
            {
              type: "text",
              name: "q15",
              title: "How are your results?",
              isRequired: false
            }
          ]
        }
      ]
    }
  ],
  showQuestionNumbers: "off"
}

@Component({
  selector: 'app-reorder-consult',
  templateUrl: './reorder-consult.component.html',
  styleUrls: ['./reorder-consult.component.css']
})
export class ReorderConsultComponent implements OnInit {
  public yourValue = 0;
  public productsList;
  public BMI = 0;
  public products = [];
  public baseUrl;
  public brand = "marsByGHC";
  constructor(public appService: AppService) {
    this.baseUrl = window.location.host.split('.').splice(1).join('.');
    if (!this.baseUrl) {
      this.baseUrl = "ghc.health";
    }
    this.alertMarsResults = this.alertMarsResults.bind(this);
    this.alertSaturnResults = this.alertSaturnResults.bind(this);
  }

  ngOnInit() {
    if (this.baseUrl == "saturn.health") {
      this.brand = "saturnByGHC"
      this.saturnSurveyJs()
    } else {
      this.brand = "marsByGHC"
      this.marsSurveyJs();
      // this.saturnSurveyJs()
    }
  }

  marsSurveyJs() {
    const survey = new Model(marsJson);
    survey.focusFirstQuestionAutomatic = false;
    survey.currentPageNo = this.yourValue;
    SurveyNG.render("surveyReorderContainer", { model: survey });
    survey.onComplete.add(this.alertMarsResults);
  }

  saturnSurveyJs() {
    const survey = new Model(saturnJson);
    survey.focusFirstQuestionAutomatic = false;
    survey.currentPageNo = this.yourValue;
    SurveyNG.render("surveyReorderContainer", { model: survey });
    survey.onComplete.add(this.alertSaturnResults);
  }
  scroll() {
    window.document.getElementById('surveyReorderResult').scrollIntoView();
  }
  alertMarsResults(sender: any) {
    this.scroll()
    console.log(sender.data)
    switch (sender.data.category) {
      case 'Hair':
        if (sender.data.ques1 == 'Stage 1') {
          this.getProducts(sender, 6933666726052);
        } else if (sender.data.ques1 === 'Stage 2') {
          this.getProducts(sender, 6920580530340);
        } else if (sender.data.ques1 === 'Stage 3' || sender.data.ques1 === 'Stage 4' && sender.data.ques2 === "No" && sender.data.Age > 30) {
          this.getProducts(sender, 6920192950436);
        } else if (sender.data.ques1 === 'Stage 3' || sender.data.ques1 === 'Stage 4' && sender.data.ques2 === "Yes") {
          this.getProducts(sender, 6920580530340);
        } else if (sender.data.ques1 === 'Stage 5' || sender.data.ques1 === 'Stage 6' && sender.data.Age > 30 && sender.data.ques2 === 'No') {
          this.getProducts(sender, 6920192950436, 5805045711012);
        } else if (sender.data.ques1 === 'Stage 5' || sender.data.ques1 === 'Stage 6' && sender.data.Age <= 30 && sender.data.ques2 === 'No') {
          this.getProducts(sender, 6920192950436);
        } else if (sender.data.ques1 === 'Stage 5' || sender.data.ques1 === 'Stage 6' && sender.data.Age > 30 && sender.data.ques2 === 'Yes') {
          this.getProducts(sender, 5805045711012, 6920563753124)
        } else if (sender.data.ques1 === 'Stage 5' || sender.data.ques1 === 'Stage 6' && sender.data.Age <= 30 && sender.data.ques2 === 'Yes') {
          this.getProducts(sender, 6920580530340);
        } else {
          this.getProducts(sender, 6732124520612);
        }
        break;
      case 'Beard':
        if (sender.data.question2 == 'Patchy Beard' || sender.data.question2 == 'No Beard' || sender.data.question2 == 'Very less (Only moustaches and chin hair)') {
          this.getProducts(sender, 6980058677412);
        } else {
          this.getProducts(sender, 6743341072548);
        }
        break;
      case 'Wellness':
        this.calculateBMI(sender)
        if (this.BMI > 20) {
          this.getProducts(sender, 6679222288548);
        } else {
          this.getProducts(sender, 6766304428196);
        }
        break;
      case 'Skin':
        if (sender.data.q2 == 'None') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7524809375992, 6826093478052)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 6877087105188)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7524809375992, 6826132668580, 6906399129764)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6826132668580, 6826093478052)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
          }
        } else if (sender.data.q2 == 'Vitamin C') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7637440266488)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7524809375992, 6826093478052)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7524809375992, 6825877635236, 6934521708708)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7637452128504)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6906399129764, 6826093478052)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6906399129764)
          }
        } else if (sender.data.q2 == 'Salicylic Acid') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7637452128504)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 6973442228388)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7637473067256)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6826132668580, 7524810391800)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
          }
        } else if (sender.data.q2 == 'Retinol') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7524809375992, 6826093478052)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6934521708708)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7637452128504)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6906399129764, 6826093478052)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7637440266488)
          }
        } else if (sender.data.q2 == 'Kojic Acid') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 6876951576740)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7524809375992, 6825877635236, 6934521708708)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 6877027401892)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6826132668580, 6906399129764, 6826093478052)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
          }
        }
        break;
      case 'Performance':
        if (sender.data.three == 'Everytime' || sender.data.three == 'Half of the time' && sender.data.five == 'No') {
          this.getProducts(sender, 6718215651492, 5805028966564);
        } else if (sender.data.three == 'Everytime' || sender.data.three == 'Half of the time' && sender.data.five == 'Yes') {
          this.getProducts(sender, 6718215651492);
        } else if (sender.data.four == 'Yes') {
          this.getProducts(sender, 6718215651492);
        } else if (sender.data.three == 'Everytime' || sender.data.four == 'Yes') {
          this.getProducts(sender, 6718215651492, 5805028966564);
        } else if (sender.data.two == 'Rarely' || sender.data.four == 'Usually have high blood pressure, bot dont have any heart issues') {
          this.getProducts(sender, 6718215651492);
        } else {
          this.getProducts(sender, 6734347174052);
        }
        break;
    }
  }

  alertSaturnResults(sender: any) {
    this.scroll();
    console.log(sender.data)
    switch (sender.data.category) {
      case 'Hair':
        if (sender.data.ques1 == 'Receding hairline' && sender.data.ques2 == 'Regrowing your hair') {
          this.getProducts(sender, 7730670010590);
        } else if (sender.data.ques1 === 'Receding hairline' && sender.data.ques2 == 'Preventing future hairloss') {
          this.getProducts(sender, 7730670010590, 7730711527646);
        } else if (sender.data.ques1 === 'Receding hairline' && sender.data.ques2 === 'Both regrowth & loss prevention') {
          this.getProducts(sender, 7730703761630, 7730684985566);
        } else if (sender.data.ques1 === 'Thinning at the crown' && sender.data.ques2 == 'Regrowing your hair') {
          this.getProducts(sender, 7730767626462);
        } else if (sender.data.ques1 === 'Thinning at the crown' && sender.data.ques2 == 'Preventing future hairloss') {
          this.getProducts(sender, 7730767626462);
        } else if (sender.data.ques1 === 'Thinning at the crown' && sender.data.ques2 === 'Both regrowth & loss prevention' && sender.data.ques4 === "No") {
          this.getProducts(sender, 7730743640286, 7730703761630);
        } else if (sender.data.ques1 === 'Thinning at the crown' && sender.data.ques2 === 'Both regrowth & loss prevention' && sender.data.ques4 === "Yes") {
          this.getProducts(sender, 7730767626462, 7730703761630);
        } else if (sender.data.ques1 === 'Overall hair loss/thinning' && sender.data.ques2 == 'Regrowing your hair') {
          this.getProducts(sender, 7730767626462);
        } else if (sender.data.ques1 === 'Overall hair loss/thinning' && sender.data.ques2 == 'Preventing future hairloss') {
          this.getProducts(sender, 7730767626462, 7730670010590);
        } else if (sender.data.ques1 === 'Overall hair loss/thinning' && sender.data.ques2 === 'Both regrowth & loss prevention' && sender.data.ques4 === "No") {
          this.getProducts(sender, 7730743640286);
        } else if (sender.data.ques1 === 'Overall hair loss/thinning' && sender.data.ques2 === 'Both regrowth & loss prevention' && sender.data.ques4 === "Yes") {
          this.getProducts(sender, 7730767626462);
        } else if (sender.data.ques1 === 'Receding + overall thinning' && sender.data.ques2 == 'Regrowing your hair' && sender.data.ques4 == 'No') {
          this.getProducts(sender, 7730743640286);
        } else if (sender.data.ques1 === 'Receding + overall thinning' && sender.data.ques2 == 'Regrowing your hair' && sender.data.ques4 == 'Yes') {
          this.getProducts(sender, 7730767626462);
        } else if (sender.data.ques1 === 'Receding + overall thinning' && sender.data.ques2 == 'Preventing future hairloss' && sender.data.ques4 == 'No') {
          this.getProducts(sender, 7730743640286, 7730670010590);
        } else if (sender.data.ques1 === 'Receding + overall thinning' && sender.data.ques2 == 'Preventing future hairloss' && sender.data.ques4 == 'Yes') {
          this.getProducts(sender, 7730767626462, 7730670010590);
        } else if (sender.data.ques1 === 'Receding + overall thinning' && sender.data.ques2 == 'Both regrowth & loss prevention' && sender.data.ques4 == 'No') {
          this.getProducts(sender, 7730743640286, 7730670010590, 7730703761630);
        } else if (sender.data.ques1 === 'Receding + overall thinning' && sender.data.ques2 == 'Both regrowth & loss prevention' && sender.data.ques4 == 'Yes') {
          this.getProducts(sender, 7730767626462, 7730670010590, 7730703761630);
        }
        break;
      case 'Wellness':
        this.calculateBMI(sender)
        if (this.BMI > 25) {
          this.getProducts(sender, 7634556059870);
        } else {
          this.getProducts(sender, 7634556059870);
        }
        break;
      case 'Skin':
        if (sender.data.q2 == 'None') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7602721095902)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7451599274206, 7530237690078)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7489917550814)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7530239721694)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7530240245982, 7451599274206)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7658089087198, 7451593769182)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7602721095902, 7515411415262)
          }

        } else if (sender.data.q2 == 'Vitamin C') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7658081157342)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7451599274206, 7530237690078)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7489917550814)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7602712576222, 7451599274206)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7658065002718)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7530239721694, 7451599274206)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7515411415262, 7658081157342)
          }

        } else if (sender.data.q2 == 'Salicylic Acid') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7637452128504)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 6973442228388)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7658089087198)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6826132668580, 7524810391800)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
          }

        } else if (sender.data.q2 == 'Retinol') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 7524809375992, 6826093478052)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6934521708708)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 7637452128504)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6906399129764, 6826093478052)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7637440266488)
          }

        } else if (sender.data.q2 == 'Kojic Acid') {
          if (sender.data.q3 == 'Open pores') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580)
          }
          if (sender.data.q3 == 'Pigmentation') {
            this.getProducts(sender, 7524809375992, 7524810391800, 6906399129764)
          }
          if (sender.data.q3 == 'Acne') {
            this.getProducts(sender, 6876951576740)
          }
          if (sender.data.q3 == 'Aging') {
            this.getProducts(sender, 7524809375992, 6825877635236, 6934521708708)
          }
          if (sender.data.q3 == 'Dark circles') {
            this.getProducts(sender, 6877027401892)
          }
          if (sender.data.q3 == 'Spots & Marks') {
            this.getProducts(sender, 7524809375992, 6826132668580, 6906399129764, 6826093478052)
          }
          if (sender.data.q3 == 'Dull skin') {
            this.getProducts(sender, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
          }
        }
        break;
    }
  }

  // common fun 
  async getProducts(sender, ...args) {
    let list = await this.appService.productsList();
    this.products = list['products'].filter(item => args.includes(item.id))
    console.log(this.products)
    await this.storeAgentCrm(sender, this.products)
    await this.htmlData(sender)
  }

  htmlData(sender) {
    if (sender.data.category == 'Wellness') {
      document.querySelector('#surveyReorderResult').innerHTML = `<div style='padding: 20px; display: grid; justify-content: center; text-align: center;'>
  <h3 style='text-align: left; color: #fe8276; font-size: 20px; font-weight: 600;'>${sender.data.category} Assesment</h3> 
  <p style='text-align: left;'>We thank you for taking the assessment<br>
  After analyzing your condition, we recommend you the below product from ${this.brand}</p>` +
        `<p><b>BMI:</b> ${this.BMI} </p>` +
        this.products.map((product) => `<img style='width: 25%; margin-left: auto; margin-right: auto; padding-top: 30px;' src= ${product.images[0].src} />
  <h3 style='font-weight: 600; font-size: 24px'>${product.title}</h3>
  <p><b>Price:</b> ${product.variants[0].price}</p>`).join(``) + `</div>`;
    } else {
      document.querySelector('#surveyReorderResult').innerHTML = `<div style='padding: 20px; display: grid; justify-content: center; text-align: center;'>
    <h3 style='text-align: left; color: #fe8276; font-size: 20px; font-weight: 600;'>${sender.data.category} Assesment</h3> 
    <p style='text-align: left;'>We thank you for taking the assessment<br>
    After analyzing your condition, we recommend you the below product from marsbyGHC</p>` +
        this.products.map((product) => `<img style='width: 25%; margin-left: auto; margin-right: auto; padding-top: 30px;' src= ${product.images[0].src} />
    <h3 style='font-weight: 600; font-size: 24px'>${product.title}</h3>
    <p><b>Price:</b> ${product.variants[0].price}</p>`).join(``) + `</div>`;
    }
  }

  calculateBMI(sender) {
    let bmi = sender.data.weight / (sender.data.height * sender.data.height) * 10000
    this.BMI = Math.round(bmi * 100) / 100
  }

  storeAgentCrm(sender, products) {
    let recomm = []
    products.map(p => {
      recomm.push({
        title: p.title,
        id: p.id,
        price: p.variants[0].price,
        icon: p.images[0].src
      })
    })
    let body = {
      fName: sender.data.FirstName,
      lName: sender.data.LastName ? sender.data.LastName : "",
      email: sender.data.Email ? sender.data.Email : "",
      number: sender.data.Phone,
      age: sender.data.Age,
      weight: sender.data.weight ? sender.data.weight : 0,
      height: sender.data.height ? sender.data.height : 0,
      category: sender.data.category,
      BMI: this.BMI,
      user_survey: sender.data,
      type: "Re-Order",
      recommendation: recomm
    }
    this.appService.storeAgentCrm(body);
  }
}
